<template>
<svg data-svg-lvl-3="spread-block-spread" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 514 430"><defs><clipPath id="ls-cp"><polygon class="ls-c-1" points="210.5 113.23 61.71 113.23 61.71 317.84 61.71 327.26 210.5 327.26 359.3 327.26 359.3 113.23 210.5 113.23"/></clipPath></defs><g id="Разворот"><g class="ls-c-4"> <polygon :style="{ fill: params.slice.color }"  class="ls-c-1" points="210.5 113.23 61.71 113.23 61.71 317.84 61.71 327.26 210.5 327.26 359.3 327.26 359.3 113.23 210.5 113.23"/> <image width="1200" height="934" transform="translate(61.3 112.83) scale(0.25 0.23)" :href="params.blockImage"  v-show="params.blockImage" preserveAspectRatio="xMidYMid slice" /></g></g></svg></template>


<script>
/** Этот компонент генерируется автоматически, руками ничего менять нельзя!!! */
  
export default {props: { params: { type: Object, required: true, }, }, data() { return {} },}
</script>

<style scoped>.ls-c-1{fill:none;}.ls-c-2{opacity:0.3;}.ls-c-3{fill:#64ff00;}.ls-c-4{clip-path:url(#ls-cp);}</style>

